import type { OsasTreatmentChoiceCustomControlData } from '@common/validation/customControls/osas/osasTreatmentChoice/types';
import { CustomControlCode } from '@common/enums';
import { CustomControlRegistry } from '@frontend/components/pages/episodeCategory/customControls/customControlRegistry';
import { initialData } from './osasTreatmentChoiceData';
import { OsasTreatmentChoiceEdit } from './OsasTreatmentChoiceEdit';
import { OsasTreatmentChoiceRead } from './OsasTreatmentChoiceRead';

CustomControlRegistry.instance.register<OsasTreatmentChoiceCustomControlData>({
    EditElement: OsasTreatmentChoiceEdit,
    ReadElement: OsasTreatmentChoiceRead,
    code: CustomControlCode.OSASTreatmentChoice,
    initialData,
    version: 1,
});
